export enum RoutesAdmin {
  HOME = "/",
  LOGIN = "/login",
  COMPANIES = "/companies",
  USERS = "/users",
  CUSTOM_FIELDS = "/custom_fields",
  FIELD_TYPES = "/field_types",
  FORM_SCHEMAS = "/form_schemas",
  GLOBAL_CONFIGS = "/global_configs",
  GRID_SCHEMAS = "/grid_schemas",
  PERMISSIONS = "/permissions",
  ROLES = "/roles",
  PROFILE = "/profile",
  AUDIT_LOGS = "/auditLogs",
  AI_CONVERSATIONS = "/aiConversations",
  AI_CONVERSATION_STATS = "/aiConversationStats",
  PROVIDER_LOGS = "/providerLogs",
  ETL_JOB_LOGS = "/etlJobLogs",
  ETL_SCHEDULE = "/etlSchedules",
  BUS_STATIONS = "/busStations",
  PROCESSES = "/processes",
  MESSAGING_LOGS = "/messagingLogs",
  ALERT_CONFIGURATION = "/alert-configuration",
  GEO_AREAS = "/geoAreas",
  REPORT_MANAGEMENT = "/reportManagement",
  MAP_CACHE_STAT = "/mapCacheStat",
  ADMIN_ACTIONS = "/adminActions",
  TOOLS = "/tools",
  SUPPLIER_QUARANTINES = "/supplierQuarantines",
  BACKUP_MANAGEMENT = "/backupManagement",
  API_KEYS = "/apiKeys",
  WEBHOOKS = "/webhooks",
  WEBHOOK_LOGS = "/webhookLogs",
}
